var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSleep(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00244141,
    width: 26.0045,
    height: 26,
    rx: 13,
    fill: "url(#paint0_linear_5166_3920)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9819 6C10.1226 6 6.99756 9.13438 6.99756 13C6.99756 16.8656 10.1226 20 13.9819 20C15.8757 20 17.5913 19.2438 18.8507 18.0188C19.0069 17.8656 19.0476 17.6281 18.9476 17.4344C18.8476 17.2406 18.6319 17.1312 18.4163 17.1687C18.1101 17.2219 17.7976 17.25 17.4757 17.25C14.4476 17.25 11.9913 14.7875 11.9913 11.75C11.9913 9.69375 13.1163 7.90313 14.7819 6.95938C14.9726 6.85 15.0694 6.63125 15.0226 6.41875C14.9757 6.20625 14.7944 6.04688 14.5757 6.02813C14.3788 6.0125 14.1819 6.00312 13.9819 6.00312V6Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5166_3920",
    x1: 12.9998,
    y1: 0,
    x2: 12.9998,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7591E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F98883"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/sleep.d1dca0ea90a2cce6c0a37d76cbf795cc.svg";
export { ForwardRef as ReactComponent };